<script setup lang="ts">
import type { InsightsProps } from "./Insights.props"

defineProps<InsightsProps>()
</script>

<template>
  <div class="search-insights" v-if="insightsList">
    <p
      v-if="title"
      class="pig-bold mb-4 hidden uppercase text-green-main md:block"
    >
      {{ title }}
    </p>
    <div class="space-y-6">
      <div>
        <div class="mb-3 flex flex-wrap gap-x-6 gap-y-3">
          <UtilsButton
            class="
              custom-btn-no-padding
              custom-btn-underlined
              custom-btn-beaver-medium
            "
            v-for="{ buttonData, icon } in insightsList"
            :key="buttonData.text"
            theme="ghost-black"
            v-bind="buttonData"
          >
            <template #icon>
              <UtilsIcon
                name="Post.svg"
                class="h-5 w-5"
                v-if="icon === 'post'"
              />
              <UtilsIcon
                name="Books.svg"
                class="h-5 w-5"
                v-if="icon === 'books'"
              />
            </template>
          </UtilsButton>
        </div>
        <UtilsButton
          v-if="moreInsights"
          class="
            custom-btn-no-padding custom-btn-beaver-medium custom-btn-start
          "
          :key="moreInsights.text"
          theme="ghost-green"
          v-bind="moreInsights"
          order="last"
        >
          <template #icon>
            <UtilsIcon name="ArrowRight.svg" color="green-main" class="icon" />
          </template>
        </UtilsButton>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.icon {
  @apply h-5 w-5;
}
</style>
